<template>
  <div>
    <h3 class="header-title">Learning Payment</h3>
    <label>Let’s see your tuition teacher payment.</label>
    <br />
    <label>
      You have subscribed to the {{ user.packageName }} package, which is valid
      until {{ user.validTo }}. This subscription comes at a price of {{ user.currencyCode}} 
      {{ user.invoiceprice }} and includes a limit of
      {{ check.NumberOfStudent }} students and
      <span v-if="check.TotalTeacher === 0">Unlimited</span
      ><span v-else>{{ check.TotalTeacher }} </span> teachers.
    </label>
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your payment teacher !</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
      <CCol sm="12" class="mt-4">
        <CRow>
          <CCol sm="4">
            <v-select
              v-model="selectedMonth"
              :options="monthOptions"
              label="month"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>
          <CCol sm="4">
            <CInput
              type="text"
              placeholder="Search text"
              v-model.lazy="SearchQuery"
              @change="ApplyFilter()"
            />
          </CCol>
          <CCol sm="4">
            <div class="text-right">
              <CButton color="primary" @click="exportCSV" size="sm">
  Export CSV
</CButton>
            </div>
          </CCol>
         
        </CRow>
      </CCol>
      <CCol sm="12">
        <CDataTable
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          :items="
            user.validTo < currentDate
              ? FilteredPaymentsList.slice(0, 5)
              : FilteredPaymentsList
          "
          :fields="fields"
          items-per-page-select
          :items-per-page="small ? 5 : 10"
          clickable-rows
          sorter
          pagination
        >
          <template #TeacherName="{ item }">
            <td>
              <h6 style="color: #1e109c" class="text-uppercase">
                {{ item.Name }}
              </h6>
            </td>
          </template>

          <template #Month="{ item }">
            <td>
              <strong> {{ item.month }}</strong>
            </td>
          </template>

          <template #AttendingHours="{ item }">
            <td>
              <tr v-for="add in item.RecordPayments" v-bind:key="add.Id">
                <li class="small text-muted">
                  {{ add.StartTime | moment("DD/MM/YYYY") }} -
                  {{ add.SubjectName }} ( {{ add.SubjectHours }} ):
                  <strong>
                    {{ user.currencyCode}}  {{ add.TotalPayment }} ({{ add.Hours }} )
                  </strong>
                </li>
              </tr>
            </td>
          </template>

          <template #AdditionalPayment="{ item }">
            <td>
              <tr v-for="adds in item.Payment" v-bind:key="adds.Id">
                <li>{{ adds.AdditionalPayment }} - {{ adds.PaymentFee }}</li>
              </tr>
            </td>
          </template>

          <template #Invoice="{ item }">
            <td>
              <tr v-for="to in item.TotalAttend" v-bind:key="to.Id">
                Total Hour :
                <strong> {{ user.currencyCode}}  {{ to.TotalInvoice }} </strong>
              </tr>
              <tr v-for="py in item.TotalPaymentFee" v-bind:key="py.Id">
                Total Additional:
                <strong>{{ user.currencyCode}}  {{ py.TotalInvoice }} </strong>
              </tr>
            </td>
          </template>

          <template #Paid="{ item }">
            <td>
              <div v-if="item.Paid === 'Yes'">
                <CBadge color="success">Yes</CBadge>
              </div>
              <div v-else><CBadge color="danger">No</CBadge></div>
            </td>
          </template>
          <template #Action="{ item }">
            <td>
              <CDropdown
                toggler-text="Action"
                class="m-2 btn-act"
                color="primary"
              >
                <CDropdownItem @click="OpenAdditional(item)"
                  >Additional Payment</CDropdownItem
                >
                <CDropdownItem @click="OpenSetPayment(item)"
                  >Set Payment</CDropdownItem
                >

                <CDropdownItem @click="OpenPrintInvoice(item)"
                  >Print Slip</CDropdownItem
                >
              </CDropdown>
            </td>
          </template>
        </CDataTable>

        <CModal
          title="Additional Payment"
          size="lg"
          :show.sync="AdditionalModal"
        >
          <div>
            <h6><strong>DETAIL TEACHER</strong></h6>
            <br />
            <CCol sm="12">
              <CRow>
                <CCol md="3">
                  <strong>Teacher</strong>
                </CCol>
                <CCol md="9">
                  <span
                    ><strong>: {{ teachers.Name }}</strong></span
                  >
                </CCol>
              </CRow>
              <CRow>
                <CCol md="3">
                  <strong>Email</strong>
                </CCol>
                <CCol md="9">
                  <span>: {{ teachers.Email }} </span>
                </CCol>
              </CRow>
              <CRow>
                <CCol md="3">
                  <strong>Phone Number</strong>
                </CCol>
                <CCol md="9">
                  <span>: {{ teachers.Phone }}</span>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="8" class="mt-4">
                  <h6>
                    <strong>LIST ADDITIONAL PAYMENT</strong>
                  </h6></CCol
                >
              </CRow>
              <CCol sm="12" class="">
                <CButton
                  class="button btn-success mr-2 mt-2"
                  size="sm"
                  @click="AddAdditionalPayment"
                >
                  <CIcon name="cil-plus" /> Add New Additional Payment
                </CButton></CCol
              >
              <br />
              <table class="table">
                <thead>
                  <th>MonthYear</th>
                  <th>Payment Info</th>
                  <th>Payment Fee</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in addPays" v-bind:key="item.Id">
                    <td>
                      <vue-monthly-picker v-model="item.MonthName">
                      </vue-monthly-picker>
                    </td>
                    <td><CInput type="text" v-model="item.PaymentInfo" /></td>
                    <td><CInput type="text" v-model="item.PaymentFee" /></td>
                    <td>
                      <CRow>
                        <CButton
                          type="submit"
                          color="success"
                          class="p-2 mr-1"
                          @click="UpdateAdd()"
                        >
                          Save</CButton
                        >
                        <CButton
                          type="submit"
                          color="danger"
                          class="text-center button btn-xs btn-danger"
                          v-on:click="removeRow(index)"
                        >
                          Delete
                        </CButton>
                      </CRow>
                    </td>
                  </tr>
                  <tr v-for="item in adds" v-bind:key="item.Id">
                    <td>{{ item.MonthName }}</td>
                    <td>{{ item.PaymentInfo }}</td>
                    <td>{{ item.PaymentFee }}</td>
                    <td>
                      <CButton
                        type="button"
                        class="btn-danger"
                        @click="OpenDelete(item)"
                        >Delete</CButton
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </CCol>
          </div>
          <template #footer>
            <CButton color="info" class="p-2" @click="CloseModal()"
              >Close</CButton
            ></template
          >
        </CModal>

        <CModal title="Set Payment" size="md" :show.sync="SetPaymentModal">
          <div>
            <h6><strong>TEACHER PAYMENT</strong></h6>
            <CRow>
              <CCol md="4">
                <strong>Teacher Name</strong>
              </CCol>
              <CCol md="8">
                <span>: {{ teachers.Name }} </span>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="4">
                <strong>Month Name</strong>
              </CCol>
              <CCol md="8">
                <span>: {{ teachers.Month }} </span>
              </CCol>
            </CRow>
            <!-- <CRow>
              <CCol md="4">
                <strong>Invoice</strong>
              </CCol>
              <CCol md="8">
                <span>: {{ invoice }} </span>
              </CCol>
            </CRow>
            <br /> -->

            <hr />
            <CRow>
              <CCol sm="12" class="mt-2">
                Payment Amount: <br />
                <CInput type="text" v-model="PaymentAmounts" />
              </CCol>
            </CRow>
          </div>
          <template #footer>
            <CButton
              type="submit"
              color="info"
              class="p-2"
              @click="SubmitSetPayment()"
              >Proceed</CButton
            >
          </template>
        </CModal>
      </CCol>
    </div>
  </div>
</template>


<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import VueMonthlyPicker from "vue-monthly-picker";

Vue.use(VuejsDialog);
export default {
  name: "Tables",
  components: {
    PulseLoader,
    VueMonthlyPicker,
  },

  data() {
    return {
      payments: [],
      SearchQuery: "",
      FilteredPayments: [],
      totalRequest: "",

      selectedMonth: "ALL MONTH",
      monthOptions: [],

      perPage: 10,
      pagination: {},
      currentPage: 1,

      Busy: false,

      bordered: "",
      small: "",
      fixed: "",

      fields: [
        { key: "TeacherName" },
        { key: "Month" },
        { key: "AttendingHours" },
        { key: "AdditionalPayment" },
        { key: "Invoice" },
        { key: "Paid" },
        { key: "Action" },
      ],
      SelectedMonths: "",
      SelectedYear: "",

      AdditionalModal: false,
      adds: [],
      teachers: {},
      addPays: [],

      PaymentInfo: "",
      PaymentFee: "",
      MonthName: "",
      SetPaymentModal: false,
      PaymentAmounts: "",

      user: {},
      currentDate: new Date().toISOString().substring(0, 10),

      check: {},
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetPayment();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
    TotalAmount: {
      get: function () {
        return _.reduce(
          this.payments,
          function (memo, item) {
            return memo + item.TotalPayment;
          },
          0
        );
      },
    },
    years() {
      const year = new Date().getFullYear();

      return Array.from(
        { length: year - 2018 },
        (value, index) => 2019 + index
      );
    },
    FilteredPaymentsList() {
      if (this.SearchQuery === "") return this.FilteredPayments;
      return this.FilteredPayments.filter((item) => {
        //teacher name
        // for (const {Name} of item.Teachers) {
        //   if (
        //     Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1
        //   ) {
        //     return item
        //   }
        // }

        //subject name
        if (
          item.Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1
        ) {
          return item;
        }

        //Grade name
        if (
          item.month.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1
        ) {
          return item;
        }
      });
    },
  },
  methods: {
    CloseModal() {
    this.AdditionalModal = false; // Set AdditionalModal to false to hide the modal
  },
  RefreshData()
  {
    this.GetPayment();
  },
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetCheckTc(this.user.tuitioncenter);
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },

    // GetPayment() {
    //   this.Busy = true;
    //   this.$API
    //     .get(this.$ViewPaymentTeacher, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.Busy = false;
    //         this.payments = response.data;
    //         this.FilteredPayments = this.payments;

    //         var monthNames = _.uniq(_.map(response.data, "month"));
    //         monthNames.sort(function (a, b) {
    //           return a.toLowerCase().localeCompare(b.toLowerCase());
    //         });
    //         this.monthOptions = monthNames;
    //         this.monthOptions.unshift("ALL MONTH");
    //       }
    //     });
    // },
    GetPayment() {
  this.Busy = true;
  this.$API
    .get(this.$ViewPaymentTeacher, {
      withCredentials: true,
    })
    .then((response) => {
      if (response.status == 200 && response.data != null) {
        this.Busy = false;
        this.payments = response.data;
        this.FilteredPayments = this.payments;

        // Extract existing months from API response
        var existingMonths = _.uniq(_.map(response.data, "month"));

        // Get current year and month
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth(); // 0 = January, 1 = February, ..., 11 = December

        // Generate all months from current month to December
        const allMonths = [];
        const monthNames = [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ];

        for (let i = currentMonth; i < 12; i++) {
          const fullMonth = `${monthNames[i]} ${currentYear}`;
          allMonths.push(fullMonth);
        }

        // Merge existing months with newly generated months, ensuring no duplicates
        const mergedMonths = _.union(existingMonths, allMonths);

        // Sort months properly
        mergedMonths.sort((a, b) => {
          return new Date(`1 ${a}`).getTime() - new Date(`1 ${b}`).getTime();
        });

        // Add "ALL MONTH" at the beginning
        this.monthOptions = ["ALL MONTH", ...mergedMonths];
      }
    });
},
    ApplyFilter: function () {
      var arr = _.orderBy(this.FilteredPayments, ["Name"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ Name }) =>
          _.some([
            _.includes(!Name || Name.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilteredPayments = result;
      }
    },
    FilteredData() {
      console.log("masuk");
      this.FilteredPayments = this.payments;

      if (this.selectedMonth !== "ALL GRADE")
        this.FilteredPayments = _.filter(
          this.FilteredPayments,
          (item) => item.month === this.selectedMonth
        );
    },
    OpenAdditional(item) {
      this.teacherId = item.Id;
      this.month = item.month;
      this.$API
        .get(
          this.$GetDetailTeacher +
            "?teacherId=" +
            this.teacherId +
            "&monthName=" +
            this.month,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.teachers = response.data;
          }
        });
      this.$API
        .get(
          this.$GetAdditionalPaymentTeacher + "?teacherId=" + this.teacherId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.adds = response.data;
          }
        });
      this.AdditionalModal = true;
    },

    AddAdditionalPayment() {
      var lastId = 1;
      var length = this.addPays.length;
      if (length > 0) lastId = this.addPays[length - 1].Id;

      this.addPays.push({
        Id: lastId + 1,
        MonthName: "",
        PaymentInfo: "",
        PaymentFee: "",
      });
    },
    removeRow: function (index) {
      this.addPays.splice(index, 1);
    },

    UpdateAdd: function () {
      const formData = new FormData();

      var teacherRateJson = JSON.stringify(this.addPays);
      formData.append("additionalPaymentTeacherJson", teacherRateJson);
      formData.append("TeacherId", this.teacherId);

      return this.$API
        .post(this.$InsertAddPaymentTeacher, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.AdditionalModal = false;

           this.RefreshData();
              
            this.$dialog.alert("Success save").then(function () {});

           
          } else {
            this.Busy = false;
            this.$dialog.alert("Error").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    OpenSetPayment(item) {
      this.teacherId = item.Id;
      this.month = item.month;
      this.$API
        .get(
          this.$GetDetailTeacher +
            "?teacherId=" +
            this.teacherId +
            "&monthName=" +
            this.month,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.teachers = response.data;
          }
        });

      this.SetPaymentModal = true;
    },
    async SubmitSetPayment() {
      const formData = new FormData();
      formData.append("TeacherId", this.teacherId);
      formData.append("MonthName", this.month);
      formData.append("PaymentFee", this.PaymentAmounts);

      return this.$API
        .post(this.$InsertSetPaymentTeacher, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.SetPaymentModal = false;
            this.$dialog.alert("Success saved").then(function () {});
            this.RefreshData();
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to create ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    OpenPrintInvoice(item) {
      this.teacherId = item.Id;
      this.month = item.month;
      this.$router.push(
        "/TeacherPaymentSlip?teacherId=" +
          this.teacherId +
          "&monthName=" +
          this.month
      );
    },
    OpenDelete(item) {
      const formData = new FormData();

      formData.append("paymentId", item.Id);
      formData.append("teacherId", this.teacherId);

      return this.$API
        .post(this.$DeleteAddPayment, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog.alert("Details Deleted!");
            this.RefreshData();
            this.FormReport = false;
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    GoToRenew() {
      // window.open("https://www.pickiddo.com/RenewPackage?UserGroupId=" + this.user.usergroupId, "_blank");
      this.$router.push("/Billing");
    },
    exportCSV() {
  // Filter data based on selected month
  const filteredData = this.FilteredPaymentsList.filter(
    (item) => item.month === this.selectedMonth
  );

  // Define CSV header based on column names
  const csvHeader = ["Name", "Month", "Invoice", "Paid"];

  // Map filtered data to CSV rows
  const csvRows = filteredData.map((item) => [
    item.Name,
    item.month,
    // Format Attending Hours with a newline for each entry
    // item.RecordPayments
    // .map(
    //       (record) =>
    //         `${record.StartTime} - ${record.SubjectName} (${record.SubjectHours}): RM ${record.TotalPayment} (${record.Hours})`
    // ).join("\n"),
    // item.Payment.map((payment) => `RM ${payment.AdditionalPayment} - RM ${payment.PaymentFee}`).join(" | "),

    // Build Invoice string with conditional checks for each part to avoid "undefined" values
   // [
    //  item.TotalAttend?.[0]?.TotalInvoice !== undefined 
    //    ? `Total Hour:  ${item.TotalAttend[0].TotalInvoice}`
    //    : null,
     // item.TotalPaymentFee?.[0]?.TotalInvoice !== undefined
    //    ? `Total Additional: RM ${item.TotalPaymentFee[0].TotalInvoice}`
     //   : null
    //]
    [
    
        item.TotalAttend?.[0]?.TotalInvoice !== undefined && item.TotalPaymentFee?.[0]?.TotalInvoice !== undefined
    ? `RM ${item.TotalAttend[0].TotalInvoice + item.TotalPaymentFee[0].TotalInvoice}`
    : null
    ]
    .filter(Boolean).join(", "),  // Filter out null values and join with comma
    item.Paid
  ]);

  // Combine header and rows with double quotes around each row to support newlines
  const csvContent = [csvHeader, ...csvRows].map(row => row.map(field => `"${field}"`).join(",")).join("\n");

  // Create a Blob from CSV content
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", `payments_${this.selectedMonth}.csv`);
  link.click();
}

  },
};
</script>
<style>
.style-chooser .vs__open-indicator {
  fill: rgb(251 248 254);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 150ms
    cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855),
    -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  -webkit-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
.style-chooser .vs__clear {
  fill: rgb(251 248 254);
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
}
.style-chooser .vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #009efb;
  border-radius: 4px;
  white-space: normal;
  height: 36px;
}
.style-chooser .vs__selected {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #009efb;
  border: 1px solid #009efb;
  border-radius: 4px;
  color: #fff;
  line-height: 1.4;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
  z-index: 0;
}
.style-chooser .vs__single .vs__selected {
  background-color: #009efb;
  border-color: #009efb;
}
.custom-btn-blue {
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
}
.btn-act {
  display: inline-block;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #7460ee;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.btn-primary {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
.btn-primary:hover {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
</style>
